import React, { Component, Fragment } from 'react';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';

import NowPortalAddBankAccountModal from './component/NowPortalAddBankAccountModal';
import NowPortalEnableAutoTransferModal from './component/NowPortalEnableAutoTransferModal';
import NowInput from '../../../components/Common/NowInput';
import { formatCurrency, isEmptyObject, coverText } from '../../../utils/utils';
import {
  setGeneralError,
  startConfirm,
} from '../../../layout/components/UniversalModal/actions';
import { trans } from '../../../localization';

import {
  initWithdrawNowPortal,
  getListProvinceNowPortal,
  getListOfficeNowPortal,
  applyNewBankAccount,
  removeBankAccount,
  enableAutoTransfer,
  disableAutoTransfer,
  requestWithdrawNowPortal,
} from './actions';
import './NowPortalWithdraw.scss';
import { EnumBankAccountSource } from '../../../constants/enum';
import { NOW_PORTAL_WITHDRAW_MIN_THRESHOLD } from '../../../constants/constants';

class NowPortalWithdraw extends Component {
  state = {
    isAddBankAccountModalOpen: false,
    withdrawOtp: '',
    isOpenWithdrawRequest: false,
    isEnableAutoTransferModalOpen: false,
  };

  componentDidMount() {
    const { initWithdrawNowPortalConnect } = this.props;
    initWithdrawNowPortalConnect();
  }

  handleOpenAddNewBankAccountModal = () => {
    this.setState({ isAddBankAccountModalOpen: true });
  };

  handleCloseAddNewBankAccountModal = () => {
    this.setState({ isAddBankAccountModalOpen: false });
  };

  handleOpenEnableTransferModal = () => {
    this.setState({ isEnableAutoTransferModalOpen: true });
  };

  handleCloseEnableTransferModal = () => {
    this.setState({ isEnableAutoTransferModalOpen: false });
  };

  handleInputChange = name => (e) => {
    this.setState({ [name]: e.target.value });
  };

  handleOpenWithdrawRequest = () => {
    const {
      setGeneralErrorConnect,
    } = this.props;
    const { withdrawAmount } = this.state;

    if (withdrawAmount < NOW_PORTAL_WITHDRAW_MIN_THRESHOLD) {
      setGeneralErrorConnect(
        `${trans('np_withdraw_min_threshold')}: ${formatCurrency(
          NOW_PORTAL_WITHDRAW_MIN_THRESHOLD,
        )}`,
      );
      return;
    }

    this.requestWithdrawOTP().then((isSuccess) => {
      if (isSuccess) {
        this.setState({ isOpenWithdrawRequest: true });
      }
    });
  };

  requestWithdrawOTP = () => {
    const {
      requestWithdrawNowPortalConnect,
      withdraw: { bankAccount },
    } = this.props;
    const { withdrawAmount } = this.state;
    return requestWithdrawNowPortalConnect(bankAccount.id, withdrawAmount);
  };

  handleSubmitWithdraw = () => {
    const {
      requestWithdrawNowPortalConnect,
      withdraw: { bankAccount },
    } = this.props;
    const { withdrawAmount, withdrawOtp } = this.state;

    requestWithdrawNowPortalConnect(
      bankAccount.id,
      withdrawAmount,
      withdrawOtp,
    ).then((isSuccess) => {
      if (isSuccess) {
        toast.success(trans('np_withdraw_success'));
      } else {
        toast.error(trans('np_withdraw_fail'));
      }
      this.setState({
        isOpenWithdrawRequest: false,
        withdrawAmount: null,
        withdrawOtp: '',
      });
    });
  };

  renderWithdrawRequest() {
    const { withdrawOtp, isOpenWithdrawRequest, withdrawAmount } = this.state;

    if (!isOpenWithdrawRequest) {
      return (
        <div>
          <NowInput
            isNumberFormat
            value={withdrawAmount}
            onChange={this.handleInputChange('withdrawAmount')}
            className="input-amount"
            placeholder={trans('np_enter_withdraw_amount')}
          />
          <button
            className="btn btn-block btn-withdraw"
            onClick={this.handleOpenWithdrawRequest}
          >
            {trans('np_next')}
          </button>
        </div>
      );
    }

    return (
      <div>
        <div className="enter-otp-desc">{trans('np_enter_otp_desc')}</div>
        <div className="input-otp-wrapper">
          <NowInput
            value={withdrawOtp}
            onChange={this.handleInputChange('withdrawOtp')}
            placeholder={trans('np_enter_verification_code')}
          />
          <button className="btn btn-white btn-withdraw" onClick={this.requestWithdrawOTP}>
            {trans('np_resend_otp')}
          </button>
        </div>
        <button className="btn btn-block btn-withdraw" onClick={this.handleSubmitWithdraw}>
          {trans('np_next')}
        </button>
      </div>
    );
  }

  render() {
    const {
      isAddBankAccountModalOpen,
      isEnableAutoTransferModalOpen,
    } = this.state;
    const {
      withdraw: {
        bankAccount,
        bankOptions,
        bankMapping,
        balance,
        bankTransfer,
      },
      getListBankNowPortalConnect,
      getListProvinceNowPortalConnect,
      getListOfficeNowPortalConnect,
      setGeneralErrorConnect,
      applyNewBankAccountConnect,
      enableAutoTransferConnect,
      disableAutoTransferConnect,
      removeBankAccountConnect,
    } = this.props;
    const hasBankAccount = !isEmptyObject(bankAccount);
    const allowChangeBankAccount =
      bankTransfer.account_src_type === EnumBankAccountSource.MERCHANT.id;

    return (
      <Fragment>
        <div className="now-portal-withdraw">
          <div className="total-title">{trans('np_total_balance')}</div>
          <div className="total-number">
            {formatCurrency(balance.cash_balance || 0)}
          </div>
          <div className="total-title">{trans('np_on_hold_balance')}</div>
          <div className="on-hold-number">
            {formatCurrency(balance.on_hold_balance || 0)}
          </div>
          <div className="divider" />
          <div className="title">{trans('np_withdraw_to_bank_account')}</div>
          {hasBankAccount && !isEmptyObject(bankMapping) && (
            <Fragment>
              <div className="bank-name detail-desc">
                <div>{bankAccount.holder_name}</div>
                <div>
                  <img
                    src={bankMapping[bankAccount.channel_id].icon_url}
                    alt=""
                    style={{ width: 16, height: 16, marginRight: 5 }}
                  />
                  {bankMapping[bankAccount.channel_id].common_name}
                </div>
                <div>{coverText(bankAccount.account_no)}</div>
              </div>
              {allowChangeBankAccount && (
                <div className="bank-actions detail-desc">
                  <button
                    className="btn btn-link"
                    onClick={this.handleOpenAddNewBankAccountModal}
                  >
                    {trans('np_add_bank_account')}
                  </button>
                  <button
                    className="btn btn-link"
                    onClick={removeBankAccountConnect}
                  >
                    {trans('general_remove')}
                  </button>
                </div>
              )}
            </Fragment>
          )}
          {!hasBankAccount && allowChangeBankAccount && (
            <button
              className="btn btn-white btn-block"
              onClick={this.handleOpenAddNewBankAccountModal}
            >
              {trans('np_add_bank_account')}
            </button>
          )}
          {this.renderWithdrawRequest()}

          <div className="note-withdraw">
            {trans('np_note')}<br />
            {trans('np_withdraw_note')}
          </div>
          {hasBankAccount && !bankTransfer.is_auto_enabled && (
            <Fragment>
              <div className="note-transfer">
                <span>{trans('np_withdraw_auto_transfer_desc')}</span>
              </div>
              <button
                className="btn btn-decline"
                onClick={this.handleOpenEnableTransferModal}
              >
                {trans('np_enable')}
              </button>
            </Fragment>
          )}
          {hasBankAccount && bankTransfer.is_auto_enabled && (
            <Fragment>
              <div className="note-transfer">
                <span>
                  {trans('rebranding.np_withdraw_auto_transfer_enabled_desc')}{' '}
                  {formatCurrency(bankTransfer.min_threshold)}
                </span>
              </div>
              <button
                className="btn btn-decline"
                onClick={disableAutoTransferConnect}
              >
                {trans('general_cancel')}
              </button>
            </Fragment>
          )}
        </div>
        <NowPortalAddBankAccountModal
          getListBankNowPortal={getListBankNowPortalConnect}
          getListProvinceNowPortal={getListProvinceNowPortalConnect}
          getListOfficeNowPortal={getListOfficeNowPortalConnect}
          setGeneralError={setGeneralErrorConnect}
          applyNewBankAccount={applyNewBankAccountConnect}
          isOpen={isAddBankAccountModalOpen}
          onRequestClose={this.handleCloseAddNewBankAccountModal}
          bankOptions={bankOptions}
        />
        <NowPortalEnableAutoTransferModal
          isOpen={isEnableAutoTransferModalOpen}
          onRequestClose={this.handleCloseEnableTransferModal}
          enableAutoTransfer={enableAutoTransferConnect}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  withdraw: state.portal.withdraw,
});

const mapDispatchToProps = {
  initWithdrawNowPortalConnect: initWithdrawNowPortal,
  getListProvinceNowPortalConnect: getListProvinceNowPortal,
  getListOfficeNowPortalConnect: getListOfficeNowPortal,
  setGeneralErrorConnect: setGeneralError,
  applyNewBankAccountConnect: applyNewBankAccount,
  removeBankAccountConnect: removeBankAccount,
  enableAutoTransferConnect: enableAutoTransfer,
  disableAutoTransferConnect: disableAutoTransfer,
  requestWithdrawNowPortalConnect: requestWithdrawNowPortal,
  startConfirmConnect: startConfirm,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NowPortalWithdraw);



// WEBPACK FOOTER //
// ./foody/src/pages/NowPortal/NowPortalWithdraw/NowPortalWithdraw.jsx